import React from 'react';

import { Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import CornerScrews from '../CornerScrews';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '410px',
    border: '6px solid rgb(50, 50, 50)',
    padding: '0',
    borderRadius: '5px',
    background:
      'linear-gradient(to bottom right, rgb(56, 56, 56) 0%, rgb(60, 60, 60) 100%)',
    boxShadow: '0 0 10px black',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '330px',
    marginLeft: '10px',
  },
  outerContainer: {
    height: '100%',
    padding: '35px 35px',
    borderRadius: '3px',
  },
  innerContainer: {
    backgroundColor: 'rgb(50, 50, 50)',
    height: '100%',
    borderRadius: '12px',
    padding: '20px',
  },
  minitsd: {
    backgroundColor: 'rgb(19, 24, 62)',
    height: '100%',
    borderRadius: '3px',
    boxShadow: '0 0 1px white',
    color: 'white',
    fontSize: '12px',
    padding: '10px',
  },
}));

interface IMiniTSDProps {}

const MiniTSD: React.FC<IMiniTSDProps> = (props) => {
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <CornerScrews />
      <Container className={classes.outerContainer}>
        <Container className={classes.innerContainer}>
          <Container className={classes.minitsd}>
            <Grid container>
              <Grid container>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <p>VT125</p>
                </Grid>
                <Grid item xs={4}>
                  <p>1.101.003</p>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <p>E/D</p>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <p>PTT TEST</p>
                </Grid>
                <Grid item xs={4}>
                  <p>ENTER to proceed,</p>
                </Grid>
                <Grid item xs={4}>
                  <p>CANCEL leave test</p>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <p>Press PTT switch</p>
                </Grid>
                <Grid item xs={4}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <p style={{ color: 'yellow' }}>ENTER</p>
                </Grid>
                <Grid item xs={4}>
                  <p style={{ color: 'yellow' }}>CANCEL</p>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Container>
      </Container>
      <CornerScrews />
    </Container>
  );
};

export default MiniTSD;
